import { render, staticRenderFns } from "./TotalCfg.vue?vue&type=template&id=4cee21e0&scoped=true"
import script from "./TotalCfg.vue?vue&type=script&lang=js"
export * from "./TotalCfg.vue?vue&type=script&lang=js"
import style0 from "./TotalCfg.vue?vue&type=style&index=0&id=4cee21e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cee21e0",
  null
  
)

export default component.exports